/**
 * Crowd Count perf timing.
 * Dev: on by default. Force: localStorage.ccPerf = '1' | '0'
 * Production: always off unless ccPerf=1.
 * Filter console: `[ccPerf]`
 */
const readFlag = () => {
  try {
    const v = localStorage.getItem('ccPerf');
    if (v === '0') return false;
    if (v === '1') return true;
  } catch { /* private mode / SSR */ }
  return process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test';
};

let ON = readFlag();

const isEnabled = () => ON;

const now = () => (typeof performance !== 'undefined' ? performance.now() : Date.now());

const mark = (name, ms, extra) => {
  if (!ON) return;
  const line = `[ccPerf] ${name}: ${Number(ms).toFixed(1)}ms`;
  if (extra !== undefined) console.log(line, extra); // eslint-disable-line no-console
  else console.log(line); // eslint-disable-line no-console
};

const span = (name, t0, extra) => mark(name, now() - t0, extra);

/** Run fn, log duration. Returns fn result. */
const measure = (name, fn, extra) => {
  const t0 = now();
  const out = fn();
  span(name, t0, typeof extra === 'function' ? extra(out) : extra);
  return out;
};

const enable = (on = true) => {
  ON = Boolean(on);
  try { localStorage.setItem('ccPerf', ON ? '1' : '0'); } catch { /* noop */ }
};

/** Re-read flag (tests / after localStorage change without enable()). */
const refresh = () => {
  ON = readFlag();
  return ON;
};

export {
  isEnabled,
  isEnabled as enabled,
  now,
  mark,
  span,
  measure,
  enable,
  refresh,
};
